
const sollyFields = ['solly_error','solly_tarifs','solly_ref','solly_validated']

export default class DataSolly {

    constructor(devis) {
        for ( const field of sollyFields ) {
            this[field] = devis[field]
        }
        this.formule = devis.params.formule
        this.periodicite = devis.params.periodicite
    }

    hasSolly() {
        return !! this.solly_ref
    }

    hasTarifs( key ) {
        const f = key || this.formule
        return ( this.solly_validated>=0 )&& this.solly_tarifs[f] && !! this.solly_tarifs[f].annuel
    }
    tarifs( key ) {
        const f = key || this.formule
        return this.solly_tarifs[f]
    }

    acompte( key ) {
        const f = key || this.formule
        return f ? parseFloat( this.solly_tarifs[f]?.acompte ) : 0
    }

    mensuel( key ) {
        const f = key || this.formule
        return f ? parseFloat( this.solly_tarifs[f]?.mensuel ) : 0
    }

    annuel( key ) {
        const f = key || this.formule
        return f ? parseFloat( this.solly_tarifs[f]?.annuel ) : 0
    }

    frais( key ) {
        return ( this.acompte(key) && this.mensuel(key) )?( this.acompte(key) - this.mensuel(key) ) : 0
    }

    toPayMonthlyYearlyFormule() {
        return (this.periodicite=='M')?this.mensuel():this.annuel()
    }

    toPayMonthlyYearlyOptions() {
        return 0 // Add options
    }

    toPayMonthly() {
        return this.mensuel() // Add options
    }

    toPayYearly() {
        return (this.periodicite=='M') ?( this.acompte() + 11*this.mensuel() ): this.annuel() // Add options
    }

    toPay() {
        return (this.periodicite=='M') ? this.acompte() : this.annuel() // Add options
    }

}

DataSolly.zFormToDisplay = {
    'M2':'Formule au Tiers',
    'M3':'Formule Tiers + Vol & Incendie',
    'M4':'Formule Vol + Dommage Collision',
    'M7':'Formule Tous risques'
}

DataSolly.zFormToExplain = {
    'M2':'Responsabilité Civile et Défense Pénale et Recours Suite à Accident',
    'M3':'Catastrophes Naturelles, Catastrophes Technologiques, attentats, Garantie valeur à neuf, garantie caques et gants, protection juridique',
    'M4':'Accident avec un tiers identifié',
    'M7':'Dommages tous accidents'
}

DataSolly.zFormToUniqueDetails = {
    'M3':<p><h3>Garanties uniques de l'offre Assur Bon Plan</h3>Explosion / Tempête/ Bris des glaces cylindrée &gt; 50 cm³ / garantie valeur à neuf pendant 12 mois suivant l’achat pour les véhicules acquis neufs</p>
}
